import { render, staticRenderFns } from "./PackagingMotorManual.vue?vue&type=template&id=b277e4c0"
import script from "./PackagingMotorManual.vue?vue&type=script&lang=js"
export * from "./PackagingMotorManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports